import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { messageError, messageToast } from '../../utils/define';
import { updateAccountAuthInfoAction } from '../../store/reducers/account';

import { ACCOUNT_EMAIL_API } from '../../utils/apiUrl';
import { Post } from '../../utils/httpProvider';

const schema = yup.object().shape({
    lastName: yup.string().required(messageError.emptyMessage),
    middleName: yup.string(),
    firstName: yup.string().required(messageError.emptyMessage),
    email: yup
        .string()
        .email(messageError.emailMessage)
        .required(messageError.emptyMessage)
});

const SettingsTab = ({ isActive, profile, onUpdated }) => {
    const dispatch = useDispatch();

    const handleUpdate = async (values, actions) => {
        if (!profile || !profile.id) {
            toast.error('Không tìm thấy thông tin tài khoản');
            return;
        }

        const fullName = `${values.lastName} ${values.middleName || ''} ${values.firstName}`.replace(/\s+/g, ' ').trim();

        try {
            // 1. Lưu Email vào CSDL DbKpiC9 của phân hệ KPI
            const resKpi = await Post(ACCOUNT_EMAIL_API.UPSERT, null, {
                accountId: profile.id,
                email: values.email?.trim(),
                fullName
            });
            const dataKpi = await resKpi.json();

            // Nếu trùng email với tài khoản khác trong nội bộ KPI C9 -> Cảnh báo cho người dùng biết
            if (dataKpi?.isDuplicate && dataKpi?.warning) {
                toast.warn(dataKpi.warning);
            }

            // 2. Cập nhật thông tin họ tên lên AuthService qua AccountAuthInfo/UpdateItem
            const targetAuthInfoId = profile.authInfoId || profile.id;
            const modelUpdate = {
                id: targetAuthInfoId,
                data: {
                    accountId: profile.id,
                    lastName: values.lastName,
                    middleName: values.middleName,
                    firstName: values.firstName,
                    email: values.email
                }
            };
            try {
                await dispatch(updateAccountAuthInfoAction(modelUpdate));
            } catch (authErr) {
                // Bỏ qua nếu AuthService báo lỗi trùng email hoặc không có quyền vì KPI C9 đã lưu thành công
            }

            if (onUpdated) {
                onUpdated(values);
            }

            toast.success('Cập nhật thông tin và Email nhận thông báo thành công');
        } catch (error) {
            toast.error(messageToast.messageToastTryCatch);
        }
    };

    return (
        <div className={`tab-pane ${isActive ? 'active' : ''}`}>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values, actions) =>
                        handleUpdate(values, actions)
                    }
                    initialValues={{
                        lastName: profile?.lastName || '',
                        middleName: profile?.middleName || '',
                        firstName: profile?.firstName || '',
                        email: profile?.email || ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Họ *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Nhập họ"
                                        name="lastName"
                                        value={values.lastName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.lastName}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.lastName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên đệm
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Nhập tên đệm"
                                        name="middleName"
                                        value={values.middleName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.middleName}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Nhập tên"
                                        name="firstName"
                                        value={values.firstName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.firstName}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.firstName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Email *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Nhập email"
                                        name="email"
                                        value={values.email}
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.email}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <Button type="submit" theme="primary">
                                        Cập nhật thông tin
                                    </Button>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </div>
    );
};

export default SettingsTab;
